import LicenseDetail from '@/components/licenses/LicenseDetail.jsx';

export default function ProducerLicenseDetail() {
  return <LicenseDetail kind="producer" />;
}
